"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

var _actions = require("../actions");

var _helpers = require("../helpers");

var _LoginForm = _interopRequireDefault(require("../components/LoginForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LogIn = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LogIn, _React$Component);

  function LogIn(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (formData) {
      _this.props.loginUserandGetData(formData.email, formData.password, _this.props.product).then(function (success) {
        return success === true ? _this.props.history.push(_this.props.redirectTo) : false;
      });
    });

    _this.state = {
      authToken: (0, _helpers.getAuthToken)()
    };
    return _this;
  }

  var _proto = LogIn.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.clearLoginForm();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isFetching = _this$props.isFetching,
        error = _this$props.error,
        loginStatus = _this$props.loginStatus,
        showRegisterLink = _this$props.showRegisterLink;
    return /*#__PURE__*/React.createElement("div", {
      className: "page--multifaceted-bg-grey"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Container, {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout"
    }, /*#__PURE__*/React.createElement("h2", null, "Log In"), /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 10
    }, /*#__PURE__*/React.createElement("p", {
      className: "login-comment"
    }, "Your roymorgan.com credentials are the same for all products."), error && /*#__PURE__*/React.createElement(_semanticUiReact.Message, {
      warning: true,
      icon: false,
      content: error
    }), /*#__PURE__*/React.createElement(_LoginForm["default"], {
      handleSubmit: this.handleSubmit,
      isFetching: isFetching || loginStatus,
      error: error,
      showRegisterLink: showRegisterLink
    })))))))));
  };

  return LogIn;
}(React.Component);

_defineProperty(LogIn, "defaultProps", {
  redirectTo: '/'
});

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    loginStatus: state.auth.loginStatus.isFetching,
    error: state.auth.user.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loginUserandGetData: _actions.loginUserandGetData,
    clearLoginForm: _actions.clearLoginForm
  }, dispatch);
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LogIn));

exports["default"] = _default;